module.exports = __webpack_public_path__ + "img/15_44.fca90aaf.png";